module.exports = __webpack_public_path__ + "img/banner2.852af294.jpg";